import cn from "classnames"
import { lazy, Suspense, useEffect, useRef } from "react"

import { useGetTenantConfigurations } from "@/api/useTenant"
import { Flex, Skeleton } from "@/atoms"
import { ErrorBoundary } from "@/organisms/ErrorBoundary"
import { ScrollBottomButton } from "./components/ScrollBottomButton"

import styles from "./KaiChat.module.scss"

import type { KaiChatProps } from "."

const Chat = lazy(() => import("./components/Chat/Chat"))

export const KaiChat = (props: KaiChatProps) => {
  const containerRef = useRef<HTMLDivElement>(null)
  const { response } = useGetTenantConfigurations()
  const { kaiAccessExternalWebSource, kaiChatbot } = response?.data || {}

  useEffect(() => {
    const el = document.getElementsByClassName("ant-app")[0]

    if (!el) return

    el.classList.add(styles.background)

    return () => el.classList.remove(styles.background)
  }, [])

  useEffect(() => {
    if (!kaiChatbot && props.open) props.toggle()

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [kaiChatbot])

  const { open, ...rest } = props

  return (
    <>
      <Flex
        vertical
        ref={containerRef}
        gap={8}
        className={cn(styles.container, open && styles.open)}
      >
        <ErrorBoundary {...rest}>
          <Suspense
            fallback={
              <Flex vertical className={styles.skeleton}>
                <div className={styles.wrapper}>
                  <Skeleton.Input active block />
                </div>
                <Flex vertical flex={1}>
                  <Skeleton active />
                  <Skeleton active />
                  <Skeleton active />
                </Flex>
                <div className={styles.wrapper}>
                  <Skeleton.Input active block />
                </div>
              </Flex>
            }
          >
            <Chat
              containerRef={containerRef}
              kaiAccessExternalWebSource={kaiAccessExternalWebSource}
            />
          </Suspense>
        </ErrorBoundary>
      </Flex>
      {open && <ScrollBottomButton parent={containerRef.current} />}
    </>
  )
}
